import { Component, Inject, OnInit } from '@angular/core';
import { ProtocolResponsibility } from '../../../model/protocol';
import { ArrayUtils } from '../../../utils/arrayUtils';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../services/snackBar.service';
import { ThemeService } from '../../../services/theme.service';

export interface DialogDataResponsabilities {
  responsibility: ProtocolResponsibility;
  isEdit: boolean;
  disabled: boolean;
}

@Component({
  selector: 'app-edit-responsibilities',
  templateUrl: './edit-responsibilities.component.html',
  styleUrls: ['./edit-responsibilities.component.scss'],
  standalone: false
})
export class EditResponsibilitiesComponent {

 constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogDataResponsabilities,
    public dialogRef: MatDialogRef<EditResponsibilitiesComponent>,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    private themeService: ThemeService) { }

  onOkClick(): void {
    const errors = [];

    const item = this.data.responsibility;

    if (item.action == null) {
      errors.push(this.translate.instant('protocolEdit.responsibilities.form.error.action'));
    }

     if (item.responsible == null) {
      errors.push(this.translate.instant('protocolEdit.responsibilities.form.error.responsible'));
    }

    if (ArrayUtils.isEmpty(errors)) {
      this.dialogRef.close(item);
    } else {
      const error = errors.join('\n');
      this.snackBarService.sendError(error);
      console.error(error);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }

}

